import { Action, Dispatch } from 'redux'
import { State } from 'index'
import format from 'date-fns/format'
import { FirebaseDocRefType, FirebaseDocumentDataType } from 'firebase/index'
import { fetchStocksAction } from 'reducks/stock/actions'
import { mergeStocks } from 'reducks/stock/operations'
import { StockUnionType } from 'types/stock'

// 特定商品の未来の在庫データを全て取得
const fetchFutureStocks = (params: {
  storeRef: FirebaseDocRefType
  types: Array<StockUnionType>
  breadRef?: FirebaseDocRefType
  isExcludingDeletedStock?: boolean
}) => {
  const { storeRef, types, breadRef, isExcludingDeletedStock = true } = params
  return async (dispatch: Dispatch<Action>, getState: () => State) => {
    const manufacturerRef = getState().auth.manufacturer_ref
    const date = format(new Date(), 'yyyyMMdd')
    // 該当する注文種別の在庫を取得
    let query = storeRef.collection('store_stocks').where('type', 'in', types)
    // 特定商品の在庫を取得
    if (typeof breadRef !== 'undefined') {
      query = query.where('bread_ref', '==', breadRef)
    }
    // sacri stationモードの場合、生産店舗のrefを条件に追加
    if (typeof manufacturerRef !== 'undefined') {
      query = query.where('manufacturer_ref', '==', manufacturerRef)
    }

    const stocks = await query
      .orderBy('date', 'asc')
      .startAt(date)
      .get()
      .then((snapshots: FirebaseDocumentDataType) => {
        return mergeStocks(snapshots, isExcludingDeletedStock)
      })
      .catch((error: unknown) => {
        console.error(error)
        return []
      })

    dispatch(fetchStocksAction(stocks))
  }
}

export default fetchFutureStocks
